var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUvIndex01 = function SvgUvIndex01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uv-index-01_svg2__a",
    x1: 54.33,
    x2: 497.33,
    y1: 510.61,
    y2: 105.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv-index-01_svg2__a",
    id: "uv-index-01_svg2__b",
    x1: 123.76,
    x2: 566.76,
    y1: 586.56,
    y2: 181.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv-index-01_svg2__a",
    id: "uv-index-01_svg2__c",
    x1: 131.28,
    x2: 574.28,
    y1: 594.78,
    y2: 189.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv-index-01_svg2__a",
    id: "uv-index-01_svg2__d",
    x1: -44.02,
    x2: 398.98,
    y1: 403.04,
    y2: -1.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv-index-01_svg2__a",
    id: "uv-index-01_svg2__e",
    x1: 38.2,
    x2: 481.2,
    y1: 492.97,
    y2: 87.97,
    gradientTransform: "rotate(45 436.387 128.927)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv-index-01_svg2__a",
    id: "uv-index-01_svg2__f",
    x1: 164.73,
    x2: 607.73,
    y1: 631.37,
    y2: 226.37,
    gradientTransform: "rotate(45 436.357 383.045)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv-index-01_svg2__a",
    id: "uv-index-01_svg2__g",
    x1: 46.69,
    x2: 489.69,
    y1: 502.25,
    y2: 97.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv-index-01_svg2__a",
    id: "uv-index-01_svg2__h",
    x1: 78.81,
    x2: 521.81,
    y1: 537.39,
    y2: 132.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv-index-01_svg2__a",
    id: "uv-index-01_svg2__i",
    x1: -34.07,
    x2: 408.93,
    y1: 413.92,
    y2: 8.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv-index-01_svg2__a",
    id: "uv-index-01_svg2__j",
    x1: -36.65,
    x2: 406.35,
    y1: 411.1,
    y2: 6.1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M309.33 106.67c-3.86 0-7.69.15-11.48.44l1.63 21.27c3.25-.25 6.53-.37 9.85-.37 70.69 0 128 57.31 128 128s-57.31 128-128 128c-3.31 0-6.59-.12-9.83-.37l-1.64 21.27c3.79.29 7.62.44 11.48.44 82.47 0 149.33-66.86 149.33-149.33s-66.86-149.33-149.33-149.33Z",
    style: {
      fill: "url(#uv-index-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.33 245.33h32v21.33h-32z",
    style: {
      fill: "url(#uv-index-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.67 416H320v32h-21.33z",
    style: {
      fill: "url(#uv-index-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.67 64H320v32h-21.33z",
    style: {
      fill: "url(#uv-index-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.05 118.26h32.68v21.33h-32.68z",
    style: {
      fill: "url(#uv-index-01_svg2__e)"
    },
    transform: "rotate(-45 436.394 128.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.69 366.7h21.33v32.68h-21.33z",
    style: {
      fill: "url(#uv-index-01_svg2__f)"
    },
    transform: "rotate(-45 436.353 383.047)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 266.67V224h-21.33v42.67c0 5.89-4.78 10.67-10.67 10.67s-10.67-4.78-10.67-10.67V224H288v42.67c0 17.67 14.33 32 32 32s32-14.33 32-32",
    style: {
      fill: "url(#uv-index-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.67 224v21.33c-.02 1.65.35 3.28 1.07 4.77l21.33 42.67c1.82 3.63 5.54 5.92 9.6 5.9 4.06.02 7.78-2.26 9.6-5.9l21.33-42.67a10.8 10.8 0 0 0 1.07-4.77V224h-21.33v18.82l-10.67 21.33L384 242.82V224z",
    style: {
      fill: "url(#uv-index-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 0H53.33C23.89.04.04 23.89 0 53.33v405.33c.04 29.44 23.89 53.3 53.33 53.33H224c29.44-.04 53.3-23.89 53.33-53.33V53.33C277.29 23.89 253.44.03 224 0M53.33 21.33H224c17.67 0 32 14.33 32 32V96h-21.33v21.33H256V192H21.33v-74.67h192V96h-192V53.33c0-17.67 14.33-32 32-32M224 490.67H53.33c-17.67 0-32-14.33-32-32V416h192v-21.33h-192V320h21.33v-21.33H21.33v-85.33H256v13.01l-77.26 19.31c-3.82.96-6.8 3.94-7.75 7.75-1.43 5.71 2.04 11.51 7.75 12.94L256 285.66v13.01H106.67V320H256v74.67h-21.33V416H256v42.67c0 17.67-14.33 32-32 32m32-242.34v15.34L225.31 256z",
    style: {
      fill: "url(#uv-index-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 298.67h21.33V320H64z",
    style: {
      fill: "url(#uv-index-01_svg2__j)"
    }
  }));
};
export default SvgUvIndex01;